import { BaseFilter } from './base.filter';

export class CalendarEventFilter extends BaseFilter {
  locationId: string;
  residentApplicationId: string;
  from: any;
  to: any;
}
